import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { finalize, first } from 'rxjs/operators';
import {
  Observable,
  distinctUntilChanged,
  debounceTime,
  filter,
  map,
  FormBuilder,
  FormGroup,
  Validators,
  NgbModal,
} from '../../common/angular.index';
import {
  ALERTS,
  Contact,
  Email,
  Parameter,
  ReportParameter,
} from 'src/app/common/models.index';
// services
import {
  AlertService,
  BlockUIHandlerService,
  CommonService,
  RptManagerService,
} from 'src/app/common/services.index';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { merge, Subject, Subscription } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


// const 

@Component({
  selector: 'app-print-report',
  templateUrl: './print-report.component.html',
  styleUrls: ['./print-report.component.css'],
})
export class PrintReportComponent implements OnInit, OnDestroy {
  // VARBOX
  superMatrix:number[][];
  focus$: Subject<string>[]; // Variable usada para mapear los eventos del typeahead y focus en la matrix de parametros dinamicos
  click$: Subject<string>[];// Variable usada para mapear los eventos del typeahead y focus en la matrix de parametros dinamicos

  modalRef: any;
  @Input() reportId: number;
  routerEventsSubs: Subscription;

  parameters: ReportParameter[];
  parameterSubgroup1: ReportParameter[];
  parameterSubgroup2: ReportParameter[];
  parameterSubgroup3: ReportParameter[];
  parameterSubgroup4: ReportParameter[];
  paramaterListGroup: ReportParameter[][];

  parametersForm: FormGroup;
  emailForm: FormGroup;
  emailRecipients: string[];
  reportKeys: Parameter[];
  contacts: Contact[];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private rptManagerService: RptManagerService,
    private alertService: AlertService,
    private blockUI: BlockUIHandlerService,
    private commonService: CommonService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit(): void {
    this.emailForm = this.formBuilder.group({
      Subject: ['', Validators.required],
      Body: ['', Validators.required],
      Recipient: [''],
    });
    this.initApp();
    this.routerEventsSubs = this.router.events
      .pipe(filter((event$) => event$ instanceof NavigationEnd))
      .subscribe(() => this.initApp());
  }

  ngOnDestroy() {
    this.routerEventsSubs.unsubscribe();
  }

  resetEmailForm() {
    this.emailForm.reset({
      Subject: '',
      Body: '',
      Recipient: '',
    });
  }

  resetParameterForm() {
    for (const control in this.parametersForm.controls) {
      this.parametersForm.get(control).reset();
    }
  }

  ResetMatrix(): void {
    this.superMatrix = [];
    for(let c = 0; c < 4; c++) {
      this.superMatrix[c] = [];
      for(let d = 0; d < 4; d++) {
        this.superMatrix[c][d] = -1;
      }
    }
  }

  initApp() {
    this.ResetMatrix();
    //this.reportId = Number(this.route.snapshot.paramMap.get('reportId'));
    this.parametersForm = this.formBuilder.group({});
    this.resetEmailForm();
    this.emailRecipients = [];
    this.parameters = [];
    this.reportKeys = [];
    this.parameterSubgroup1 = [];
    this.parameterSubgroup2 = [];
    this.parameterSubgroup3 = [];
    this.parameterSubgroup4 = [];
    this.paramaterListGroup = [];
    this.paramaterListGroup.push(
      this.parameterSubgroup1,
      this.parameterSubgroup2,
      this.parameterSubgroup3,
      this.parameterSubgroup4
    );
    //this.getContacts();
    this.getParameters();
  }

  getParameters() {
    this.blockUI.Start(1, `Procesando, espere por favor`);
    this.rptManagerService
      .GetParameters(this.reportId, true)
      .pipe(finalize(() => this.blockUI.taskFinished()))
      .subscribe(response => {
          if (response.Result) {
            this.parameters = response.Parameters;
            if (response.Parameters) {
              this.ResetMatrix();
              console.log(this.superMatrix);
              this.focus$ = response.Parameters.map((param, index)=>{
                this.superMatrix[param.GridCol][param.GridRow] = index;
                return new Subject<string>();
              });
              this.click$ = response.Parameters.map(_=>new Subject<string>());
              response.Parameters.forEach((x) => {
                x.MappedPrealoadSource = x.PreloadedSource?.map(x => `${x.Code} - ${x.Description}`);

                switch (x.GridCol) {
                  case 0:
                    this.parameterSubgroup1.push(x);
                    break;
                  case 1:
                    this.parameterSubgroup2.push(x);
                    break;
                  case 2:
                    this.parameterSubgroup3.push(x);
                    break;
                  case 3:
                    this.parameterSubgroup4.push(x);
                    break;
                }
              });
              this.alertService.ShowSmallCornerAlert(`Operación terminada`, ALERTS.success);
            }
            

            this.setFormControls();
          } else {
            this.alertService.ShowBigCenteredAlert(response.ErrorInfo.Message, ALERTS.error);
          }
        },err => {
          this.alertService.ShowBigCenteredAlert(err, ALERTS.error);
        }
      );
  }

  getContacts() {
    throw Error('Method not implemented');
  }

  searchContact = ($text: Observable<string>) =>
    $text.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term: string) =>
        !term || term.length === 0
          ? this.contacts.map((x) => `${x.Email}`).slice(0, 10)
          : this.contacts
              .filter(
                (x) =>
                  x.Email.toUpperCase().search(term.toUpperCase()) > -1 ||
                  x.Name.toUpperCase().search(term.toUpperCase()) > -1
              )
              .map((x) => `${x.Email}`)
              .slice(0, 10)
      )
    );

  onContactSelected(event$) {
    event$.preventDefault();
    console.log('email',event$.item)
    this.addRecipient(event$.item);
  }

  addRecipient(recipient: string) {
    
    if (!recipient) return;
    if (!this.emailRecipients.some((x) => x === recipient))
      this.emailRecipients.push(recipient);
    this.emailForm.get('Recipient').reset();
  }

  onClickRemoveRecipient(index: number) {
    this.emailRecipients.splice(index, 1);
  }

  onClickPrintReport() {
    this.blockUI.Start(1, `Procesando, espere por favor`);
    const parameters: Parameter[] = this.getParametersForReportPrint();
    console.log(parameters);
    this.rptManagerService
      .PrintReport(parameters, this.reportId)
      .pipe(finalize(() => this.blockUI.taskFinished()))
      .subscribe(
        (response) => {

          if (response.Result) {
             this.commonService.downloadFile(
              response.Print,
              'Reporte',
              'application/pdf',
              'pdf'
            );
            this.alertService.ShowSmallCornerAlert(`Operación terminada`, ALERTS.success);
          } else {
            this.alertService.ShowBigCenteredAlert(
              response.ErrorInfo.Message,
              ALERTS.error
            );
          }
        },
        (err) => {
          console.log(err);
          this.alertService.ShowBigCenteredAlert(err, ALERTS.error);
        }
      );
  }

  onClickSendEmail() {
    this.blockUI.Start(1, `Procesando, espere por favor`);
    let email: Email = {
      Body: this.emailForm.get('Body').value,
      Recipients: this.emailRecipients,
      Subject: this.emailForm.get('Subject').value,
      Parameters: this.getParametersForReportPrint(),
    };

    this.rptManagerService
      .SendEmail(email, this.reportId)
      .pipe(finalize(() => this.blockUI.taskFinished()))
      .subscribe(response => {
          if (response.Result) {
            this.alertService.ShowSmallCornerAlert('Operación terminada', ALERTS.success);
            this.resetEmailForm();
            this.emailRecipients = [];
            this.dismissModal(true);
          } else {
            this.alertService.ShowBigCenteredAlert(response.ErrorInfo.Message, ALERTS.error);
          }
        }, err => {
          console.info(err);
          this.alertService.ShowBigCenteredAlert(err, ALERTS.error);
        }
      );
  }

  getParametersForReportPrint() {
    let parameters: Parameter[] = [];
    if (this.parameters) {
      this.parameters.forEach((x) => {
        
        let parameter: Parameter = {
          Key: x.Name,
          Type: x.Type,
          Value: this.ParseUserInput(this.parametersForm.get(x.Name).value, x.Type, x.MappedPrealoadSource),
        };

        parameters.push(parameter);
      });

      console.log(parameters);
    }

    return parameters;
  }

  ParseUserInput(_inputValue: any, _type: number, _mappedPreloadSource: string[]): string {
    try {
      const HAS_MAPPED_PRELOAD_SOURCE = _mappedPreloadSource && _mappedPreloadSource.length > 0;

      let mappedUserInput = _inputValue;

      switch(_type) {
        case 5:
          break;
        default:
          if (HAS_MAPPED_PRELOAD_SOURCE && !!_inputValue && `${_inputValue}`.split(` - `).length > 1) {
            mappedUserInput =  `${_inputValue}`.split(` - `)[0];
          }
          break;
      }

      return mappedUserInput;
    }
    catch(error) {
      console.info(error);
      return null;
    }
  }

  setFormControls() {
    this.parameters.forEach((x) => {
      this.parametersForm.addControl(
        x.Name,
        !x.Required
          ? new FormControl('')
          : new FormControl('', {
              validators: Validators.required,
            })
      );
    });
  }

  onClickSendMailModal(modalSendMail: any) {
    this.modalRef = this.modalService.open(modalSendMail, {
      backdrop: true,
      scrollable: true,
      size: 'lg',
    });
  }

  dismissModal(result: boolean) {
    this.modalRef.close();
  }

  get emailFormControls() {
    return this.emailForm.controls;
  }

  searchType(index,instance, data,text$) { //<--pass "data"
    return (text$: Observable<string>) => {
      const debouncedText$ = text$.pipe(
        debounceTime(200),
        distinctUntilChanged()
      );
      const clicksWithClosedPopup$ = this.click$[index].pipe(
        filter(() => !instance.isPopupOpen())
      );
      const inputFocus$ = this.focus$[index];

      return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
        map(term =>
          (term === ""
            ? data          //<--here use data
            : data?.filter(  //<--here use data too
                v => v.toLowerCase().indexOf(term.toLowerCase()) > -1
              )
          )?.slice(0, 5)
        )
      );
    };
  }

  GetIndex(i: number, j: number) {
    const POSITION = this.superMatrix[i][j];
    return POSITION;
  }
}
